import transform from '@/services/tiers/filters/tiersServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/Tiers/';

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function get(idTiers) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idTiers } });
  return response;
}

export async function getWithLiensInferieurs(idTiers, includeAllChild) {
  const response = await HTTP.get(URL_BASE + 'GetWithLiensInferieursAsync', { params: { id: idTiers, includeAllChild: includeAllChild } });
  return response;
}

export async function create(tiers) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', tiers);
  return response;
}

export async function createAll(listeTiers, modeTest, compteurError) {
  const mode = modeTest ? '?modeTest=true' : '?modeTest=false';
  const errorCounter = compteurError ? '&compteurError=true' : '&compteurError=false';
  const response = await HTTP.post(`${URL_BASE}CreateAllAsync${mode}${errorCounter}`, listeTiers);
  return response;
}

export async function update(tiers) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', tiers);
  return response;
}

export async function remove(idTiers) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idTiers } });
  return response;
}

export async function getAllByTradeName(nomTiers, societeId, type, sousTypes) {
  const params = {
    nomCommercial: nomTiers,
    societeId: societeId,
  };
  if (type && type !== undefined) {
    params.type = type;
  }
  if (sousTypes && sousTypes.length > 0) {
    params.sousTypes = sousTypes;
  }
  const response = await HTTP.post(URL_BASE + 'PGetAllByTradeNameAsync', params);
  return response;
}

export async function getAllAvecContact(nomEtContact, societeId, type, sousType) {
  const queryItems = {
    query: {
      nomEtContact: nomEtContact,
      societeId: societeId,
      type: type,
      sousType: sousType,
    },
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllAvecContactAsync', queryItems);
  return response;
}

export async function archiver(listeId) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', listeId);
  return response;
}

export async function bloquer(dto) {
  const response = await HTTP.post(URL_BASE + 'BloquerAsync', dto);
  return response;
}
export async function generateMandat(dto) {
  const response = await HTTP.post(URL_BASE + 'GenerationMandatAsync', dto);
  return response;
}
export async function deleteBailleur(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllBailleurAsync', { bailleurIds: ids });
  return response;
}

export async function PGetAllTiersByUserIds(ids) {
  const response = await HTTP.post(URL_BASE + 'PGetAllTiersByUserIdsAsync', ids);
  return response;
}

export async function fusionTiersAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'FusionAsync', payload);
  return response;
}

export async function deleteTiersAsync(tiersId) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: tiersId } });
  return response;
}

export async function archiverEnMasse(params) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAllAsync', params);
  return response;
}
